import { Box, Text } from '@betty/moonlight';
import { memo, useCallback } from 'react';
import { Pressable } from 'react-native';
import { MyProfileReadOnlyFieldProps } from './MyProfileReadOnlyField.types';
import { useNavigation } from '@betty/navigation';

function MyProfileReadOnlyField({
  locKey,
  value,
  targetScreen,
}: MyProfileReadOnlyFieldProps) {
  const navigation = useNavigation();

  const onPressHandler = useCallback(() => {
    if (targetScreen) {
      navigation.navigate(targetScreen);
    }
  }, [targetScreen, navigation]);

  return (
    <Box
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
      borderColor="borderWashed"
      borderBottomWidth="border-width-025"
      gap="space-300"
    >
      <Text
        locNS="account"
        locKey={locKey}
        variant="body-m"
        color="darkSurfacePrimary"
        paddingBottom="space-100"
      />
      <Box
        flexDirection="row"
        centerContent
        gap="space-300"
        flex={1}
        flexWrap="wrap"
        justifyContent="flex-end"
      >
        <Text variant="body-m" color="darkSurfacePrimary">
          {value}
        </Text>
        {targetScreen ? (
          <Pressable onPress={onPressHandler}>
            <Text
              locNS="account"
              locKey="myProfileEditCta"
              variant="body-m"
              gradient="darkSurfaceAccent"
            />
          </Pressable>
        ) : null}
      </Box>
    </Box>
  );
}

export default memo(MyProfileReadOnlyField);
